import { PluginKey } from '@atlaskit/editor-prosemirror/state';

export const getEditorViewPluginKey: PluginKey = new PluginKey('aiExperienceGetEditorView');
